module.exports = __webpack_public_path__ + "img/authLogo.ea3f2d4c.svg";